module.exports = __webpack_public_path__ + "static/sport/register-btn.0d35054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register-btn.png
// module id = sOzD
// module chunks = 0